module.exports = __webpack_public_path__ + "static/media/speaker.3090ed91.svg";